// User Management Page Mock Data - SAT V4 Zone

export interface UserManagementTabConfig {
  id: string;
  label: string;
  description: string;
}

export const userManagementTabConfigs: UserManagementTabConfig[] = [
  {
    id: 'teachers',
    label: 'Teachers',
    description: 'Manage teacher profiles, subjects, and availability',
  },
  {
    id: 'pupils',
    label: 'Pupils',
    description: 'Manage pupil profiles, subjects, and special requirements',
  },
  {
    id: 'parentsCarers',
    label: 'Teacher Preferences',
    description: 'Manage parent and carer contact information',
  },
  {
    id: 'validation',
    label: 'Validation',
    description: 'Validate user data for completeness',
  },
];

export interface TeacherDetailTabConfig {
  id: string;
  label: string;
  description: string;
}

export const teacherDetailTabConfigs: TeacherDetailTabConfig[] = [
  {
    id: 'profile',
    label: 'Profile',
    description: 'Personal information and contact details',
  },
  {
    id: 'subjects',
    label: 'Subjects',
    description: 'Assigned subjects and qualifications',
  },
  {
    id: 'workload',
    label: 'Period & Workload Tracking',
    description: 'Teaching hours and workload distribution',
  },
  {
    id: 'availability',
    label: 'Availability',
    description: 'Weekly availability schedule',
  },
  {
    id: 'rulesPreferences',
    label: 'Rules & Preferences',
    description: 'Teaching preferences and scheduling rules',
  },
];

export interface PupilDetailTabConfig {
  id: string;
  label: string;
  description: string;
}

export const pupilDetailTabConfigs: PupilDetailTabConfig[] = [
  {
    id: 'profile',
    label: 'Profile',
    description: 'Personal information and enrollment details',
  },
  {
    id: 'subjects',
    label: 'Subjects',
    description: 'Subject choices and class assignments',
  },
  {
    id: 'specialRequirements',
    label: 'SEND',
    description: 'SEN, medical, and other requirements',
  },
  {
    id: 'parentsCarers',
    label: 'Parents & Carers',
    description: 'Contact information for parents and carers',
  },
];

export const roleColors: Record<string, string> = {
  'Head of department': '#4CAF50',
  'Head of Year': '#2196F3',
  SLT: '#9C27B0',
  SEND: '#FF9800',
  Safeguarding: '#F44336',
  Behavior: '#FF5722',
  Attendance: '#00BCD4',
};

export const statusColors: Record<string, string> = {
  active: '#4CAF50',
  inactive: '#9E9E9E',
  on_leave: '#FF9800',
};
